/**
 * @generated SignedSource<<dd38d7d98fc7756978393393dba3e4e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type IntegrationNewsfeedProvider = "BOKAKLIPP" | "FALCON";
export type IntegrationNewsfeedScreenUpdateMutation$variables = {
  id: string;
  info: string;
  provider: IntegrationNewsfeedProvider;
};
export type IntegrationNewsfeedScreenUpdateMutation$data = {
  readonly store: {
    readonly updateIntegrationNewsfeed: {
      readonly id: string;
      readonly provider: IntegrationNewsfeedProvider;
    } | null;
  };
};
export type IntegrationNewsfeedScreenUpdateMutation = {
  response: IntegrationNewsfeedScreenUpdateMutation$data;
  variables: IntegrationNewsfeedScreenUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "info"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "provider"
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StoreMutations",
    "kind": "LinkedField",
    "name": "store",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          },
          {
            "kind": "Variable",
            "name": "info",
            "variableName": "info"
          },
          {
            "kind": "Variable",
            "name": "provider",
            "variableName": "provider"
          }
        ],
        "concreteType": "IntegrationNewsfeed",
        "kind": "LinkedField",
        "name": "updateIntegrationNewsfeed",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "provider",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationNewsfeedScreenUpdateMutation",
    "selections": (v3/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "IntegrationNewsfeedScreenUpdateMutation",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "a49d4ffe91ee19095a5aefbbdb21854d",
    "id": null,
    "metadata": {},
    "name": "IntegrationNewsfeedScreenUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation IntegrationNewsfeedScreenUpdateMutation(\n  $id: ID!\n  $provider: IntegrationNewsfeedProvider!\n  $info: String!\n) {\n  store {\n    updateIntegrationNewsfeed(id: $id, provider: $provider, info: $info) {\n      id\n      provider\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "eea3929f96baef62091f78cf1b5b0316";

export default node;
